import React, { useEffect, useState } from 'react';
import './Day.css'; // Assuming you have a CSS file for styling
import Unit from '../Modular/Unit';
import Button from '../Button';
import MicroUnit from '../Modular/MicroUnit';

interface DayProps {
  day: number;
  selectDay: (day: number) => void;
  isAvailable: boolean;
  children: number;
  month: number;
  width: '1' | '3';
}

const Day: React.FC<DayProps> = ({
  day,
  selectDay,
  isAvailable,
  month,
  width,
}) => {
  const variant = isAvailable ? 'primary' : 'outlinelight';

  return (
    <Button onClick={() => selectDay(day)} variant={variant} width={width}>
      <MicroUnit as="p" pTypography="label" height="2">
        {day}
      </MicroUnit>
    </Button>
  );
};

export default Day;
